"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const fixedStreamSelectors_1 = require("../../../../../store/fixedStreamSelectors");
const hooks_1 = require("../../../../../store/hooks");
const mobileStreamSelectors_1 = require("../../../../../store/mobileStreamSelectors");
const thresholdSlice_1 = require("../../../../../store/thresholdSlice");
const filters_1 = require("../../../../../types/filters");
const useScreenSizeDetection_1 = __importDefault(require("../../../../../utils/useScreenSizeDetection"));
const S = __importStar(require("../SessionDetailsModal.style"));
const ModalDesktopHeader_1 = __importDefault(require("./ModalDesktopHeader"));
const ModalMobileHeader_1 = __importDefault(require("./ModalMobileHeader"));
const SessionInfo = ({ sessionType, streamId, isVisible, setIsVisible, }) => {
    const fixedSessionTypeSelected = (0, react_1.useMemo)(() => sessionType === filters_1.SessionTypes.FIXED, [sessionType]);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const streamShortInfo = (0, hooks_1.useAppSelector)(fixedSessionTypeSelected
        ? fixedStreamSelectors_1.selectFixedStreamShortInfo
        : mobileStreamSelectors_1.selectMobileStreamShortInfo);
    const extremes = (0, hooks_1.useAppSelector)(fixedSessionTypeSelected ? fixedStreamSelectors_1.selectFixedExtremes : mobileStreamSelectors_1.selectMobileExtremes);
    const thresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const toggleVisibility = () => setIsVisible(!isVisible);
    const commonProps = {
        streamShortInfo,
        thresholds,
        extremes,
    };
    if (isMobile) {
        return (react_1.default.createElement(S.InfoContainer, null,
            react_1.default.createElement(ModalMobileHeader_1.default, Object.assign({}, commonProps, { toggleVisibility: toggleVisibility, isVisible: isVisible, isMobile: isMobile }))));
    }
    return (react_1.default.createElement(S.InfoContainer, null,
        react_1.default.createElement(ModalDesktopHeader_1.default, Object.assign({}, commonProps, { fixedSessionTypeSelected: fixedSessionTypeSelected, streamId: streamId }))));
};
exports.default = react_1.default.memo(SessionInfo);
